module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gb-sct-bea4865f11865ef5646547efd1a78c32.svg";